<template>
	<div class="invitation-card">
		<van-loading size="24px" v-show="!cardImageData && !imgfail">生成中...</van-loading>
		<img ref="cardImg" :src="cardImageData" class="card-show" />
		<canvas ref="paintAvatar" style="display: none"></canvas>
		<canvas ref="painting" style="display: none"></canvas>
		<vue-qr ref="qr" :margin="5" :text="qrcodeLocal.url" :size="qrcodeLocal.size" style="display: none"></vue-qr>
	</div>
</template>
<script>
import vueQr from "vue-qr";

export default {
	props: {
		param: {
			type: Object,
			default: () => {
				return {
					image: "",
					qrcode: {
						url: "",
					},
					avatar: "",
					nickname: "",
				};
			},
		},
	},
	components: { vueQr },
	data() {
		return {
			canvas: null,
			ctx: null,
			cardImageData: "",

			avatarCanvas: null,
			avatarCtx: null,
			imgfail:false,
			qrcodeLocal: {
				url: "",
				tmpUrl: "",
				size: 120,
			},
			// 固定布局参数（基准尺寸，基于750宽设计）
			layoutConfig: {
				cardWidth: 750,    // 画布总宽度
				cardHeight: 1200,   // 画布总高度
				topAreaHeight: 200, // 上部区域高度
				midAreaHeight: 600, // 中部图片区域高度
				bottomAreaHeight: 400, // 下部二维码区域高度
				avatarSize: 120,    // 头像尺寸
				avatarX: 40,        // 头像X坐标
				avatarY: 40,        // 头像Y坐标
				nicknameX: 200,     // 昵称X坐标
				nicknameY: 80,      // 昵称Y坐标
				inviteTextY: 140,   // 邀请语Y坐标
				midImgX: 50,        // 中部图片X坐标
				midImgY: 220,       // 中部图片Y坐标
				midImgWidth: 650,   // 中部图片容器宽度
				midImgHeight: 580,  // 中部图片容器高度
				qrCodeX: 295,       // 二维码X坐标（居中）
				qrCodeY: 850,       // 二维码Y坐标
				qrCodeSize: 200,    // 二维码尺寸
				qrTextX: 800,       // 二维码文字X坐标
				qrTextY: 1100,      // 二维码文字Y坐标
				qrTextSize: 32      // 二维码文字大小
			}
		};
	},
	computed: {},
	watch: {
		param(newV, oldV) {
			if (newV && newV.image) {
				this.qrcodeLocal.url = "";
				this.qrcodeLocal.tmpUrl = this.param.qrcode.url;
				this.draw();
			}
		},
	},
	mounted() {
		console.log("邀请卡 mounted", this.$el);
		// 初始化画布
		this.canvas = this.$refs.painting;
		this.ctx = this.canvas.getContext("2d");

		// 初始化头像画布
		this.avatarCanvas = this.$refs.paintAvatar;
		this.avatarCanvas.width = this.layoutConfig.avatarSize;
		this.avatarCanvas.height = this.layoutConfig.avatarSize;
		this.avatarCtx = this.avatarCanvas.getContext("2d");

		// 初始绘制
		if (this.param.image) {
			this.draw();
		}

		// this.canvas = this.$refs.painting;
		// this.canvas.width = this.$el.clientWidth;
		// this.canvas.height = this.$el.clientHeight;
		// // this.canvas.style.border = "1px solid red";

		// this.ctx = this.canvas.getContext("2d");

		// this.avatarCanvas = this.$refs.paintAvatar;
		// this.avatarCanvas.width = 220;
		// this.avatarCanvas.height = 220;
		// this.avatarCtx = this.avatarCanvas.getContext("2d");
	},
	beforeDestroy() {},
	methods: {
		/**
		 * 核心绘制方法 - 按新布局重构
		 */
		async draw() {
			this.imgfail = false;
			
			try {
				// 1. 初始化画布尺寸
				const { cardWidth, cardHeight } = this.layoutConfig;
				this.canvas.width = cardWidth;
				this.canvas.height = cardHeight;
				this.ctx.clearRect(0, 0, cardWidth, cardHeight);

				// 2. 绘制上部区域（头像+昵称+邀请语）
				await this.drawTopArea();

				// 3. 绘制中部区域（分享图片，等比展示）
				await this.drawMiddleArea();

				// 4. 绘制下部区域（二维码+文字）
				await this.drawBottomArea();

				// 5. 生成最终图片
				this.cardImageData = this.canvas.toDataURL("image/png");
				this.$emit("get-image", this.cardImageData);
				
			} catch (err) {
				console.error("邀请卡绘制失败:", err);
				this.$toast("图片生成失败，请重试");
				this.imgfail = true;
			}
		},
		/**
		 * 绘制上部区域：头像（左） + 昵称+邀请语（右）
		 */
		async drawTopArea() {
			const { 
				avatarSize, avatarX, avatarY, 
				nicknameX, nicknameY, inviteTextY,
				topAreaHeight
			} = this.layoutConfig;

			// 绘制上部背景（可选，可根据需求调整）
			this.ctx.fillStyle = "#f5f5f5";
			this.ctx.fillRect(0, 0, this.layoutConfig.cardWidth, topAreaHeight);

			// 绘制圆形头像
			if (this.param.avatar) {
				const imgAvatar = await this.imgLoad(this.param.avatar + `?${Math.random()}`);
				
				// 清空头像画布
				this.avatarCtx.clearRect(0, 0, avatarSize, avatarSize);
				
				// 绘制圆形头像
				this.avatarCtx.save();
				this.avatarCtx.beginPath();
				this.avatarCtx.arc(avatarSize/2, avatarSize/2, avatarSize/2, 0, Math.PI * 2);
				this.avatarCtx.clip();
				this.avatarCtx.drawImage(imgAvatar, 0, 0, avatarSize, avatarSize);
				this.avatarCtx.restore();

				// 将头像绘制到主画布
				this.ctx.drawImage(this.avatarCanvas, avatarX, avatarY, avatarSize, avatarSize);
			}

			// 绘制昵称
			this.ctx.save();
			this.ctx.fillStyle = "#333333";
			this.ctx.font = `bold 36px Arial`;
			this.ctx.fillText(this.param.nickname || "用户", nicknameX, nicknameY);

			// 绘制邀请语
			this.ctx.fillStyle = "#666666";
			this.ctx.font = `28px Arial`;
			this.ctx.fillText("邀您一起看直播", nicknameX, inviteTextY);
			this.ctx.restore();
		},
		/**
		 * 绘制中部区域：分享图片（固定容器，等比展示）
		 */
		async drawMiddleArea() {
			const { midImgX, midImgY, midImgWidth, midImgHeight } = this.layoutConfig;
			
			if (!this.param.image) return;

			// 加载分享图片
			const imgImage = await this.imgLoad(this.param.image);

			// 计算等比缩放比例
			const scale = Math.min(
				midImgWidth / imgImage.width,
				midImgHeight / imgImage.height
			);
			const imgDrawWidth = imgImage.width * scale;
			const imgDrawHeight = imgImage.height * scale;

			// 居中绘制图片
			const imgStartX = midImgX + (midImgWidth - imgDrawWidth) / 2;
			const imgStartY = midImgY + (midImgHeight - imgDrawHeight) / 2;

			// 绘制图片容器背景
			this.ctx.fillStyle = "#ffffff";
			this.ctx.fillRect(midImgX, midImgY, midImgWidth, midImgHeight);

			// 绘制分享图片
			this.ctx.drawImage(
				imgImage,
				0,
				0,
				imgImage.width,
				imgImage.height,
				imgStartX,
				imgStartY,
				imgDrawWidth,
				imgDrawHeight
			);
		},
		/**
		 * 绘制下部区域：二维码 + 文字
		 */
		async drawBottomArea() {
			const { cardWidth, qrCodeSize, qrCodeY, qrTextY, qrTextSize } = this.layoutConfig;

			// 设置二维码尺寸并触发生成
			this.qrcodeLocal.size = qrCodeSize;
			this.qrcodeLocal.url = this.qrcodeLocal.tmpUrl;

			// 等待二维码生成
			await new Promise(resolve => setTimeout(resolve, 200));

			// 加载二维码图片
			if (this.$refs.qr && this.$refs.qr.imgUrl) {
				const imgCode = await this.imgLoad(this.$refs.qr.imgUrl);
				
				// 正确计算二维码居中X坐标：(画布宽度 - 二维码宽度) / 2
				const qrDrawX = (cardWidth - qrCodeSize) / 2;
				this.ctx.drawImage(imgCode, qrDrawX, qrCodeY, qrCodeSize, qrCodeSize);
			}

			// 绘制二维码下方文字
			this.ctx.save();
			this.ctx.fillStyle = "#333333";
			this.ctx.font = `${qrTextSize}px Arial`;
			this.ctx.textAlign = "center";
			this.ctx.fillText("长按保存图片，邀请好友观看直播！", cardWidth / 2, qrTextY);
			this.ctx.restore();
		},
		/**
		 * 图片加载Promise封装
		 */
		imgLoad(url) {
			return new Promise((resolve, reject) => {
				if (!url) {
					reject(new Error("图片URL为空"));
					return;
				}

				const img = document.createElement("img");
				img.crossOrigin = "anonymous";
				
				img.onload = () => {
					resolve(img);
					img.onload = null;
					img.onerror = null;
				};
				
				img.onerror = (err) => {
					console.error("图片加载失败:", url, err);
					reject(err);
					img.onload = null;
					img.onerror = null;
				};
				
				img.src = url;
			});
		},
		// draw() {
		// 	this.imgfail = false
		// 	// console.log("邀请卡 draw start", this.param);
		// 	setTimeout(async () => {
		// 		const imgImage = await this.imgLoad(this.param.image);
		// 		// console.log("邀请卡 draw:", imgImage.width, imgImage.height, this.param.image);

		// 		this.canvas.width = imgImage.width;
		// 		this.canvas.height = imgImage.height;
		// 		const scaleFactor = Math.min(imgImage.width / 1080, imgImage.height / 1920);  
		// 		this.ctx.drawImage(imgImage, 0, 0, imgImage.width, imgImage.height, 0, 0, this.canvas.width, this.canvas.height);
		// 		this.qrcodeLocal.size = Math.min(Math.max(Math.floor(imgImage.width / scaleFactor / 5), 100), 200);
		// 		this.qrcodeLocal.url = this.qrcodeLocal.tmpUrl;
		// 		const edge = Math.floor(this.qrcodeLocal.size / 5);
		// 		const bottomEdge = 75;
		// 		const rightEdge = 86;

		// 		// avatar
		// 		const imgAvatar = await this.imgLoad(this.param.avatar + `?${Math.random()}`);
		// 		this.avatarCtx.clearRect(0, 0, this.avatarCanvas.width, this.avatarCanvas.height);
		// 		this.avatarCtx.drawImage(imgAvatar, 0, 0, 130, 130, 50*scaleFactor, 50*scaleFactor, 150*scaleFactor, 150*scaleFactor);

		// 		this.ctx.fillStyle = this.ctx.createPattern(this.avatarCanvas, "no-repeat");
		// 		this.ctx.arc(120*scaleFactor, 120*scaleFactor, 70*scaleFactor, 0, Math.PI * 2);
		// 		this.ctx.fill();
		// 		// console.log("avatar", imgAvatar.width, imgAvatar.height, imgAvatar);

		// 		var textSize = 48*scaleFactor
		// 		// nickname
		// 		this.ctx.beginPath();
		// 		this.ctx.fillStyle = "#ffffff";
		// 		// this.ctx.font = "bold 48px Arial";
		// 		this.ctx.font = `bold ${textSize}px Arial`;
		// 		this.ctx.fillText(this.param.nickname, 240*scaleFactor, 80*scaleFactor);
		// 		this.ctx.fillText("邀你一起看直播", 240*scaleFactor, 150*scaleFactor);
		// 		this.ctx.closePath();
				
		// 		setTimeout(async () => {
		// 			const imgCode = await this.imgLoad(this.$refs.qr.imgUrl);
		// 			const codeX = this.canvas.width/scaleFactor - this.qrcodeLocal.size - rightEdge;
		// 			const codeY = this.canvas.height/scaleFactor - this.qrcodeLocal.size - bottomEdge;
		// 			this.ctx.drawImage(imgCode, 0, 0, imgCode.width, imgCode.height, (codeX-90)*scaleFactor, (codeY-90)*scaleFactor, (this.qrcodeLocal.size+75)*scaleFactor, (this.qrcodeLocal.size+75)*scaleFactor);

		// 			this.cardImageData = this.canvas.toDataURL("image/png");
		// 			// console.log(">>>>>>>>>>>", this.canvas.toDataURL("image/png"));
		// 			this.$emit("get-image", this.cardImageData);
		// 		}, 1000);
		// 	}, 100);
		// },
		// imgLoad(url) {
		// 	return new Promise((resolve, reject) => {
		// 		const img = document.createElement("img");
		// 		img.crossOrigin = "anonymous";
		// 		img.onload = () => {
		// 			// img.height=430
		// 			// img.width = 241
		// 			resolve(img);
		// 			img.onload = null;
		// 			img.onerror = null;
		// 		};
		// 		img.onerror = (err) => {
		// 			console.error("邀请卡图片生成失败:", url, err);
		// 			this.$toast("图片生成失败，请重试");
		// 			this.imgfail = true
		// 			img.onload = null;
		// 			img.onerror = null;
		// 			reject(err);
		// 		};
		// 		img.src = url;
		// 	});
		// },
	},
};
</script>
<style lang="less" scoped>
.invitation-card {
	width: 100%;
	height: 100%;
	position: relative;
	background-color: #fff;
	border-radius: 12px;
	overflow: hidden;
	.card-show {
		width: 100%;
		height: auto;
		display: block;
	}
}
.van-loading{
		color: #666;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.van-loading__text{
	color: #666;
}
</style>